import { useQuery } from 'react-query'
import { config } from 'config'
import { AuthContainer } from 'containers'
import { callAxios, CustomAxiosError } from 'utils/api'
import { getParamsForAll, getQueryParamsForAll } from 'utils/hooks'

const { SECURE_BASE_URL } = config!

type SubCategoryResponse = { commercial_class: string }[]

type GetSubCategoryRequest = {
  vendorNumber: string
  division: string[]
  category: string[]
  reportName?: string
}

const getSubCategory = async (props: GetSubCategoryRequest): Promise<SubCategoryResponse> => {
  const { vendorNumber, division, category, reportName } = props

  let queryParams = `vendornumber=${vendorNumber}`

  queryParams = getQueryParamsForAll(queryParams, 'commercial_division', division)
  queryParams = getQueryParamsForAll(queryParams, 'commercial_category', category)

  if (reportName) queryParams += `&reportname=${reportName}`

  const { response: subCategoryResponse } = await callAxios<{
    response: { data: SubCategoryResponse }
  }>({
    url: `${SECURE_BASE_URL}/subcategory?${queryParams}`,
    method: 'GET',
  })

  const filteredSubCategoryResponse = subCategoryResponse.data?.filter((item) => !!item.commercial_class)

  return filteredSubCategoryResponse
}

export const useGetSubCategory = (props: Omit<GetSubCategoryRequest, 'vendorNumber'>) => {
  const { division, category, reportName } = props
  const { selectedSupplier } = AuthContainer.useContainer()
  const vendorNumber = selectedSupplier?.oracleId ?? ''

  const isEnabled = !!division.length && !!category.length

  const {
    status: getSubCategoryStatus,
    isFetching: getIsSubCategoryLoading,
    data: subCategoryData,
    error: getSubCategoryError,
  } = useQuery<SubCategoryResponse, CustomAxiosError>(
    ['subCategory/get', vendorNumber, getParamsForAll(division, 'only'), getParamsForAll(category, 'only'), reportName],
    () => getSubCategory({ ...props, vendorNumber }),
    {
      enabled: isEnabled,
    }
  )
  return {
    getSubCategoryStatus,
    getIsSubCategoryLoading,
    subCategoryData,
    getSubCategoryError,
  }
}
